export type SimpleTransformer<T> = (input: T) => T
export type Transformer<T, P> = (input: T, params?: P) => T
export type StrictTransformer<T, P> = (input: T, params: P) => T

export function applySimpleTransformers<T>(initialValue: T, transformers: SimpleTransformer<T>[]): T {
    if(transformers.length === 0) return initialValue
    return transformers.reduce((acc, transformer) => {
        return transformer(acc);
    }, initialValue);
}

export function applyTransformers<T,P>(initialValue: T, transformers?: Transformer<T, P>[], params?: P): T {
    if(!transformers || transformers.length === 0) return initialValue
    return transformers.reduce((acc, transformer) => {
        return transformer(acc, params);
    }, initialValue);
}

export function applyStrictTransformers<T,P>(initialValue: T, transformers: StrictTransformer<T, P>[], params: P): T {
    if(transformers.length === 0) return initialValue
    return transformers.reduce((acc, transformer) => {
        return transformer(acc, params);
    }, initialValue);
}
